import React from "react";
import "./About.css";
import {Link} from "react-router-dom";
import parthImage from  "./images/Self2.jpg";
import Footer from "./Footer";


class About extends React.Component{
    render(){
        return(
        <div>
            <div className = "about" >
               
                <div className = "aboutDescription">

                    <div  className = "aboutme">
                        ABOUT ME
                    </div>

                    <div className = "about1">
                        Hi, I am parth
                    </div>

                    <div className = "about2">
                    Thanks for visiting my website. I am a software developer currently working at Kinsale Insurance.
                    I have experience with fullstack development and technologies such as
                    Spring, Angular, SQL, and cloud computing.
                    </div>
                    
                    <div className = "about3">
                    I started this website in 2020 as a method to learn HTML, CSS, and React. Since then, 
                    I've gained a lot of software engineering experience. 
                    I'm constantly trying to push myself and expand my skill set. 
                    </div>
                    <div className = "about4">
                        Here are some of the skills that I have Developed/Relearned in the past few months:
                    </div>

                    <div className = "about5">
                        <div> - Event Driven Architecture</div>
                        <div> - Provisioning Infrastructure</div>
                        <div> - React</div>
                    </div>
                </div>
                
            <div className="aboutImage">
                <img className = "SelfImage" src = {parthImage}/>
            </div>

            
            </div>
            <Footer/>
        </div>
        )
    }

}

export default About;